import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Ana', 'Sofía', 'Lucía', 'Valentina', 'Camila', 'Isabella', 'Fernanda', 'Gabriela', 'Daniela'];
const CITIES = ['Buenos Aires', 'Santiago', 'Bogotá', 'Lima', 'Ciudad de México', 'Montevideo', 'Quito', 'Medellín', 'Córdoba', 'Rosario'];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    // Recurring interval
    const interval = setInterval(() => {
      showNotification();
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  };
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs w-full animate-slide-up" data-id="element-174">
      <div className="bg-white rounded-lg shadow-xl border border-purple-100 p-3 flex items-center gap-3" data-id="element-175">
        <div className="bg-green-100 rounded-full p-2 flex-shrink-0" data-id="element-176">
          <CheckCircle className="w-5 h-5 text-green-600" data-id="element-177" />
        </div>
        <div data-id="element-178">
          <p className="text-sm font-bold text-gray-900" data-id="element-179">
            {data.name} de {data.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-180">acaba de comprar el Mega Pack</p>
          <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-181">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}